const accessMaster = {

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Add Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Update Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Add State', path: '/create-state' },
    UPDATE_STATE: { name: 'Update State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Add City', path: '/create-city' },
    UPDATE_CITY: { name: 'Update City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    DEPARTMENT_LIST: { name: 'Department', path: '/department-list' },
    ADD_DEPARTMENT: { name: 'Add Department', path: '/create-department' },
    UPDATE_DEPARTMENT: { name: 'Update Department', path: '/edit-department' },
    DELETE_DEPARTMENT: { name: 'Delete Department', path: '/delete-department' },

    DESIGNATION_LIST: { name: 'Designation', path: '/designation-list' },
    ADD_DESIGNATION: { name: 'Add Designation', path: '/create-designation' },
    UPDATE_DESIGNATION: { name: 'Update Designation', path: '/edit-designation' },
    DELETE_DESIGNATION: { name: 'Delete Designation', path: '/delete-designation' },

    LOCATION_LIST: { name: 'Location', path: '/location-list' },
    ADD_LOCATION: { name: 'Add Location', path: '/create-location' },
    UPDATE_LOCATION: { name: 'Update Location', path: '/edit-location' },
    DELETE_LOCATION: { name: 'Delete Location', path: '/delete-location' },

    COMPONENT_LIST: { name: 'Component', path: '/component-list' },
    ADD_COMPONENT: { name: 'Add Component', path: '/create-component' },
    UPDATE_COMPONENT: { name: 'Update Component', path: '/edit-component' },
    DELETE_COMPONENT: { name: 'Delete Component', path: '/delete-component' },

    MAKE_LIST: { name: 'Make', path: '/make-list' },
    ADD_MAKE: { name: 'Add Make', path: '/create-make' },
    UPDATE_MAKE: { name: 'Update Make', path: '/edit-make' },
    DELETE_MAKE: { name: 'Delete Make', path: '/delete-make' },

    EQUIPMENT_LIST: { name: 'Equipment', path: '/equipment-list' },
    ADD_EQUIPMENT: { name: 'Add Equipment', path: '/create-equipment' },
    UPDATE_EQUIPMENT: { name: 'Update Equipment', path: '/edit-equipment' },
    DELETE_EQUIPMENT: { name: 'Delete Equipment', path: '/delete-equipment' },

    EQUIPMENT_ASSIGN_LIST: { name: 'Equipment Assign', path: '/equipment-assign-list' },
    ADD_EQUIPMENT_ASSIGN: { name: 'Add Equipment Assign', path: '/create-equipment-assign' },
    UPDATE_EQUIPMENT_ASSIGN: { name: 'Update Equipment Assign', path: '/edit-equipment-assign' },
    DELETE_EQUIPMENT_ASSIGN: { name: 'Delete Equipment Assign', path: '/delete-equipment-assign' },

    OBJECT_CONDITION_LIST: { name: 'Object Condition', path: '/object-condition-list' },
    ADD_OBJECT_CONDITION: { name: 'Add Object Condition', path: '/create-object-condition' },
    UPDATE_OBJECT_CONDITION: { name: 'Update Object Condition', path: '/edit-object-condition' },
    DELETE_OBJECT_CONDITION: { name: 'Delete Object Condition', path: '/delete-object-condition' },

    OBJECT_LIST: { name: 'Object', path: '/object-list' },
    ADD_OBJECT: { name: 'Add Object', path: '/create-object' },
    UPDATE_OBJECT: { name: 'Update Object', path: '/edit-object' },
    DELETE_OBJECT: { name: 'Delete Object', path: '/delete-object' },
    OBJECT_DETAILS: { name: 'Object Details', path: '/object-details' },

}

export default accessMaster;